import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/ui-kit";
import { Seo } from "@/components/Seo";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page">
      <Seo title="Checkout cancelled" description="You can pick this up any time." path="/payment/cancel" />
      <section className="relative bg-black noise pt-40 pb-32 lg:pt-52 lg:pb-40 min-h-[80vh] overflow-hidden">
        <div className="relative z-10 max-w-2xl mx-auto px-6 text-center">
          <Reveal>
            <Eyebrow>Checkout Cancelled</Eyebrow>
          </Reveal>
          <Reveal delay={100}>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white mt-6 leading-[1.06] tracking-tight">
              No pressure. <span className="text-[#D4AF37] italic">Take your time.</span>
            </h1>
          </Reveal>
          <Reveal delay={200}>
            <p className="font-body text-lg text-white/60 mt-8 leading-relaxed">
              Your card was not charged. When you&apos;re ready, the book will be right here.
              In the meantime, Chapter One is free to read.
            </p>
          </Reveal>
          <Reveal delay={280}>
            <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/preview"
                data-testid="payment-cancel-preview"
                className="inline-flex items-center gap-3 bg-[#D4AF37] hover:bg-[#E6C75A] text-black font-body font-medium text-[15px] px-8 py-4 transition-colors"
              >
                Read Chapter One <ArrowRight size={16} />
              </Link>
              <Link
                to="/checkout"
                data-testid="payment-cancel-retry"
                className="inline-flex items-center gap-2 text-white/70 hover:text-[#D4AF37] font-body font-medium border-b border-white/25 hover:border-[#D4AF37] pb-1 transition-colors"
              >
                Or try again
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
